import { Menu as MenuIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { cn } from '@/shared/lib/cn';
import { Button } from '@/shared/ui';
import { AccountMenu } from './AccountMenu';
import { CreditChip } from './CreditChip';
import { JobTray } from './JobTray';

export interface TopbarProps {
  /** Page context — a title, breadcrumb, or an editor's own header content. */
  children?: React.ReactNode;
  onOpenMobileNav?: () => void;
  /** A workspace page on a phone: the page's own header needs the room the credit chip takes. */
  compact?: boolean;
  className?: string;
}

export function Topbar({ children, onOpenMobileNav, compact, className }: TopbarProps) {
  const { t } = useTranslation();
  return (
    <header
      className={cn(
        'flex h-topbar shrink-0 items-center border-b border-border bg-bg md:px-4',
        compact ? 'gap-2 px-2' : 'gap-3 px-3',
        className,
      )}
    >
      {onOpenMobileNav && (
        <Button
          variant="ghost"
          size="icon-sm"
          className="md:hidden"
          onClick={onOpenMobileNav}
          aria-label={t('a11y.mainNavigation')}
        >
          <MenuIcon className="h-4 w-4" />
        </Button>
      )}

      <div className="flex min-w-0 flex-1 items-center gap-3">{children}</div>

      <div className="flex shrink-0 items-center gap-1.5">
        {!compact && <CreditChip />}
        <JobTray />
        <AccountMenu />
      </div>
    </header>
  );
}
